import { LoginAction, LoginActionTypes } from './login.actions';

export const LOGIN_FEATURE_KEY = 'login';

export interface LoginState {
  servererror: boolean;
  submitting: boolean;
}

export interface LoginPartialState {
  readonly [LOGIN_FEATURE_KEY]: LoginState;
}

export const initialState: LoginState = {
  servererror: false,
  submitting: false,
};

export function loginReducer(
  state: LoginState = initialState,
  action: LoginAction,
): LoginState {
  switch (action.type) {
    case LoginActionTypes.LoginSubmit: {
      return {
        ...state,
        servererror: false,
        submitting: true,
      };
    }
    case LoginActionTypes.LoginError: {
      return {
        ...state,
        servererror: true,
        submitting: false,
      };
    }
    case LoginActionTypes.LoginSuccess: {
      return {
        ...state,
        servererror: false,
        submitting: false,
      };
    }
  }
  return state;
}
